function positionDropdown(picker, options) {
  const rect = picker.getBoundingClientRect();

  options.style.visibility = 'hidden';
  options.style.display = 'block';

  const dropdownRect = options.getBoundingClientRect();
  const dropdownHeight = dropdownRect.height;

  const spaceBelow = window.innerHeight - rect.bottom;
  const spaceAbove = rect.top;

  options.style.top = '';
  options.style.bottom = '';

  if (spaceBelow < dropdownHeight && spaceAbove > spaceBelow) {
    options.style.bottom = '100%';
    options.style.top = 'auto';
  } else {
    options.style.top = '100%';
    options.style.bottom = 'auto';
  }

  options.style.visibility = '';
}

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.ped-fabric-picker').forEach(picker => {

    const selected = picker.querySelector('.ped-selected');
    const options = picker.querySelector('.ped-options');
    const optionEls = picker.querySelectorAll('.ped-option');
    const layout = picker.dataset.layout;

    let selectedColour = null;

    /* =========================
       GRID MODE
    ========================= */
    if (layout === 'grid') {

      const header = picker.querySelector('.ped-accordion-header');
      const body = picker.querySelector('.ped-accordion-body');
      const items = picker.querySelectorAll('.ped-grid-item');

      // ✅ AUTO-SELECT FIRST GRID ITEM
      if (items.length > 0) {
        const first = items[0];
        first.classList.add('active');
        selectedColour = first.dataset.value;

        // Optional: update header label
        const label = header.querySelector('span');
        if (label) label.textContent = selectedColour;
      }

      // OPEN BY DEFAULT
      requestAnimationFrame(() => {
        body.style.maxHeight = body.scrollHeight + 'px';
      });

      // Toggle
      header.addEventListener('click', () => {
        const isOpen = body.style.maxHeight !== '0px';

        body.style.maxHeight = isOpen ? '0px' : body.scrollHeight + 'px';
      });

      // Select colour
      items.forEach(item => {
        item.addEventListener('click', () => {

          items.forEach(i => i.classList.remove('active'));
          item.classList.add('active');

          selectedColour = item.dataset.value;

          // Optional: update header label
          const label = header.querySelector('span');
          if (label) label.textContent = selectedColour;
        });
      });

      // Resize fix (scoped correctly now)
      window.addEventListener('resize', () => {
        if (body.style.maxHeight !== '0px') {
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    }

    /* =========================
       DROPDOWN MODE
    ========================= */
    if (layout === 'dropdown') {

      // ✅ AUTO-SELECT FIRST
      if (optionEls.length > 0) {
        const first = optionEls[0];

        const name = first.dataset.value;
        const img = first.dataset.image;

        selected.innerHTML = `
          <img src="${img}" style="width:24px;height:24px;border-radius:4px;">
          <span>${name}</span>
        `;

        selectedColour = name;
        first.classList.add('active');
      }

      // Toggle
      selected.addEventListener('click', () => {

        const isOpen = options.style.display === 'block';

        if (isOpen) {
          options.style.display = 'none';
          return;
        }

        positionDropdown(picker, options);
        options.style.display = 'block';
      });

      // Select
      optionEls.forEach(option => {
        option.addEventListener('click', () => {

          optionEls.forEach(o => o.classList.remove('active'));
          option.classList.add('active');

          const name = option.dataset.value;
          const img = option.dataset.image;

          selected.innerHTML = `
            <img src="${img}" style="width:24px;height:24px;border-radius:4px;">
            <span>${name}</span>
          `;

          selectedColour = name;
          options.style.display = 'none';
        });
      });

      // Close dropdown
      document.addEventListener('click', (e) => {
        if (!picker.contains(e.target)) {
          options.style.display = 'none';
        }
      });
    }

    /* =========================
       ADD TO CART (SHARED)
    ========================= */
    const addToCartBtn = document.querySelector('button[name="add"]');

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', () => {

        if (!selectedColour) {
          alert('Please select a fabric colour');
          return;
        }

        const form = document.querySelector('product-form-component form');
        if (!form) return;

        const existing = form.querySelector('[name="properties[Fabric Colour]"]');
        if (existing) existing.remove();

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Fabric Colour]';
        input.value = selectedColour;

        form.appendChild(input);
      });
    }

  });

});